const api = process.env.REACT_APP_API_ID;
const localApi = process.env.REACT_APP_LOCAL_API_ID || process.env.REACT_APP_API_ID || "fz14n37tgj";
const normalizeStage = (stage, fallback = "colin") => (stage || fallback).replace(/^\/+|\/+$/g, "");
const apiStage = normalizeStage(process.env.REACT_APP_API_STAGE, "colin");
const localApiStage = normalizeStage(
  process.env.REACT_APP_LOCAL_API_STAGE || process.env.REACT_APP_API_STAGE,
  "colin"
);
const local = {
  s3: {
    REGION: "ap-southeast-2",
    BUCKET: "colin-dev.beta.corelogic.io",
  },
  apiGateway: {
    REGION: "ap-southeast-2",
    URL: `https://${localApi}.execute-api.ap-southeast-2.amazonaws.com/${localApiStage}`,
  },
  apiGatewayCadastreMatch: {
    REGION: "ap-southeast-2",
    URL: "https://bgxff8yoy2.execute-api.ap-southeast-2.amazonaws.com/colin-cadastre-match",
  },
  cognito: {
    REGION: "ap-southeast-2",
    USER_POOL_ID: "ap-southeast-2_ybnkudVPx",
    APP_CLIENT_ID: "4ugdcu6bfanjii82qpnoesd98u",
    IDENTITY_POOL_ID: "ap-southeast-2:7adb7c7d-95bd-4bbf-a03e-ab8f366929d3",
  },
  oauth: {
    domain: "auth.beta.corelogic.io",
    scope: ["email", "openid", "aws.cognito.signin.user.admin"],
    redirectSignIn: "http://localhost:8080", //https://colin.beta.corelogic.io/ //http://localhost:8080/
    redirectSignOut: "http://localhost:8080",
    responseType: "code", // 'code' for Authorization code grant, 'token' for Implicit grant
    options: {
      // Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
      AdvancedSecurityDataCollectionFlag: true,
    },
  },
};

const dev = {
  s3: {
    REGION: "ap-southeast-2",
    BUCKET: "colin-dev.beta.corelogic.io",
  },
  apiGateway: {
    REGION: "ap-southeast-2",
    URL: `https://${api}.execute-api.ap-southeast-2.amazonaws.com/${apiStage}`,
    // "+process.env.REACT_API_ID+"
  },
  cognito: {
    REGION: "ap-southeast-2",
    USER_POOL_ID: "ap-southeast-2_ybnkudVPx",
    APP_CLIENT_ID: "4ugdcu6bfanjii82qpnoesd98u",
    IDENTITY_POOL_ID: "ap-southeast-2:7adb7c7d-95bd-4bbf-a03e-ab8f366929d3",
  },
  oauth: {
    domain: "auth.beta.corelogic.io",
    scope: ["email", "openid", "aws.cognito.signin.user.admin"],
    redirectSignIn: "https://colin-dev.beta.corelogic.io",
    redirectSignOut: "https://colin-dev.beta.corelogic.io",
    responseType: "code", // 'code' for Authorization code grant, 'token' for Implicit grant
    options: {
      // Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
      AdvancedSecurityDataCollectionFlag: true,
    },
  },
  env: "dev",
};

const uat = {
  s3: {
    REGION: "ap-southeast-2",
    BUCKET: "colin-uat.beta.corelogic.io",
  },
  apiGateway: {
    REGION: "ap-southeast-2",
    URL: `https://${api}.execute-api.ap-southeast-2.amazonaws.com/${apiStage}`,
  },
  cognito: {
    REGION: "ap-southeast-2",
    USER_POOL_ID: "ap-southeast-2_ybnkudVPx",
    APP_CLIENT_ID: "4ugdcu6bfanjii82qpnoesd98u",
    IDENTITY_POOL_ID: "ap-southeast-2:7adb7c7d-95bd-4bbf-a03e-ab8f366929d3",
  },
  oauth: {
    domain: "auth.beta.corelogic.io",
    scope: ["email", "openid", "aws.cognito.signin.user.admin"],
    redirectSignIn: "https://colin-uat.beta.corelogic.io",
    redirectSignOut: "https://colin-uat.beta.corelogic.io",
    responseType: "code", // 'code' for Authorization code grant, 'token' for Implicit grant
    options: {
      // Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
      AdvancedSecurityDataCollectionFlag: true,
    },
  },
  env: "uat",
};

const prod = {
  s3: {
    REGION: "ap-southeast-2",
    BUCKET: "colin.corelogic.io",
  },
  apiGateway: {
    REGION: "ap-southeast-2",
    URL: `https://${api}.execute-api.ap-southeast-2.amazonaws.com/${apiStage}`,
  },
  cognito: {
    REGION: "ap-southeast-2",
    USER_POOL_ID: "ap-southeast-2_dpb5WnKux",
    APP_CLIENT_ID: "aascuvfs0n5o9pc4a2imd1299", //   aascuvfs0n5o9pc4a2imd1299   ebnbsfje9vn8ra7eeb0fio06s
    IDENTITY_POOL_ID: "ap-southeast-2:1a45f3fe-e921-451f-9cd6-cfa08ec08c62",
  },
  oauth: {
    domain: "auth.analytics.corelogic.io",
    scope: ["email", "openid", "aws.cognito.signin.user.admin"],
    redirectSignIn: "https://colin.corelogic.io",
    redirectSignOut: "https://colin.corelogic.io",
    responseType: "code", // 'code' for Authorization code grant, 'token' for Implicit grant
    options: {
      // Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
      AdvancedSecurityDataCollectionFlag: true,
    },
  },
  env: "prod",
};

const getStageFromHostname = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const hostname = window.location.hostname.toLowerCase();

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "local";
  }
  if (hostname.includes("colin-uat.")) {
    return "uat";
  }
  if (hostname.includes("colin-dev.")) {
    return "dev";
  }
  if (hostname === "colin.corelogic.io") {
    return "production";
  }

  return null;
};

const stage = getStageFromHostname() || process.env.REACT_APP_STAGE;

const config =
  stage === "production"
    ? prod
    : stage === "uat"
    ? uat
    : stage === "dev"
    ? dev
    : local;

const exportedConfig = {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 60000000,
  ATTACHMENT_TYPE: ["jpeg", "tif", "pdf", "doc", "docx", "rtf", "html"],
  ...config,
};

export default exportedConfig;
